import{startOfDay as t}from"./startOfDay.js";function r(r,a){return+t(r)==+t(a)}export{r as default,r as isSameDay};
//# sourceMappingURL=isSameDay.js.map
